import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M2.258 4.667h27.496c1.085 1.675 1.413 3.242 1.413 3.242.664 2.758.863 5.582.83 8.108.033 2.492-.2 5.316-.864 8.107 0 0-.323 1.546-1.391 3.21H2.258C1.19 25.67.866 24.123.866 24.123c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .324-1.545 1.392-3.208",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.469 9.333c.423 2.295.555 4.592.527 6.683a34.3 34.3 0 0 1-.555 6.65H4V9.334z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.033 14h31.938q.04 1.034.026 2.016.013.964-.03 1.984H.029a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M3.498 3.109 18 16 3.498 28.89C1.425 26.795.866 24.125.866 24.125c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .559-2.67 2.632-4.766",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M3.004 3.65 17 16 3.004 28.35C1.334 26.361.866 24.123.866 24.123c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .468-2.237 2.138-4.224",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "m6.333 18.733-3.526 2.454 1.244-4.112-3.424-2.596 4.296-.087 1.41-4.059 1.411 4.059 4.296.087-3.424 2.596 1.244 4.112z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M10.334 16.355c-.157-.157-2.894-2.192-3.456-2.599-.562-.406-.719-.591-.719-.591s-.506-.916-.681-1.184-.498-.648-.922-.648-.682.25-.804.694c-.068.019-.43.24-.418.469.104-.013.762-.198.989.548s.24 1.967.006 2.571-.596 1.591-.596 1.591l.56 2.127h4.901z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagZwe = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagZwe_default = SvgFlagZwe;

export { FlagZwe_default as default };
